import { lato, nunito_sans } from '@styles/fonts'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  rootContainer: {
    // backgroundImage: `url(${bg?.src})`,
    backgroundSize: 'cover',
    padding: theme.spacing(17, 14),
    borderRadius: '60px',
    position: 'relative',
    zIndex: '99',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(15, 6),
    },
  },
  zenRootContainer: {
    background: 'none',
    border: '1px solid black',
  },
  contentContainer: {
    maxWidth: '900px',
    margin: 'auto',
  },

  iconContainer: {
    position: 'relative',
    width: '142px',
    height: '142px',
    marginBottom: theme.spacing(12),
    [theme.breakpoints.down('md')]: {
      width: '107px',
      height: '107px',
      marginBottom: theme.spacing(6),
    },
  },
  heading: {
    fontFamily: nunito_sans.style.fontFamily,
    fontSize: '72px',
    fontWeight: 800,
    lineHeight: '83px',
    textAlign: 'center',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      fontSize: '36px',
      lineHeight: '49.1px',
    },
  },
  text: {
    fontFamily: lato.style.fontFamily,
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      lineHeight: '16.8px',
    },
  },
}))

export default useStyles
